module.exports = __webpack_public_path__ + "img/ES.d8577f55.svg";